import { isURL } from '../../../utils/HelperFunctions'
import { AccessToken } from '../../../utils/authUtils'
import axios from '../../../utils/axiosWithRetry'
import { SurveyProgress } from '../../model/surveyResults'

// Legacy endpoint for survey progress
const legacySurveyProgressEndpoint = `${
  process.env.REACT_APP_URL_SURVEY_RESULTS || '/v2/survey-results'
}/api/v1.0/progress`

// New endpoint from fd-core-responses
const coreResponsesSurveyProgressEndpoint = `${
  process.env.REACT_APP_FD_CORE_RESPONSES_URL || '/v1/core-responses'
}/survey-progress`

export default class SurveyResults {
  legacySurveyProgressEndpoint: string
  coreResponsesSurveyProgressEndpoint: string

  constructor() {
    this.legacySurveyProgressEndpoint = `${
      isURL(legacySurveyProgressEndpoint)
        ? ''
        : process.env.REACT_APP_REST_DOMAIN
    }${legacySurveyProgressEndpoint}`

    this.coreResponsesSurveyProgressEndpoint = `${
      isURL(coreResponsesSurveyProgressEndpoint)
        ? ''
        : process.env.REACT_APP_REST_DOMAIN
    }${coreResponsesSurveyProgressEndpoint}`
  }

  surveysProgress(surveyIds: string[]) {
    return axios.post<SurveyProgress[]>(
      this.coreResponsesSurveyProgressEndpoint,
      {
        surveyIds
      },
      {
        headers: {
          ...AccessToken.requestHeaders()
        }
      }
    )
  }

  surveysProgressLegacy(
    surveyIds: string[],
    extraConfig?: Record<string, unknown>
  ) {
    return axios.post<SurveyProgress[]>(
      this.legacySurveyProgressEndpoint,
      {
        surveyIds
      },
      {
        headers: {
          ...AccessToken.requestHeaders()
        },
        ...extraConfig
      }
    )
  }
}
